import { throttled } from "@/lib/functions";
import { Directive } from "vue";

const __resize_observer__ = Symbol("__resize_observer__");

export const mResize: Directive<ResizeObserver> = {};
